import Grid from '@material-ui/core/Grid';
// import * as Crypto from 'crypto-js';
import Paper from '@material-ui/core/Paper';
import * as React from 'react';
import { connect } from 'react-redux';
import LoginComponent from '../components/login/loginComponent';
import { UserAuthenticationWrapper } from '../styles/login';
import { loginUser, loginAdUser, clearUser, verifyCaptcha, getAppSettings } from '../actions/action.userAuth';
import { getCurrentUrl } from 'src/effects/utils/common';
import LoaderComponent from 'src/components/common/loader.component';
import { LoginEnum } from 'src/constants/Enum/LoginEnum';
import ForgotPasswordComponent from 'src/components/login/forgotPassword/ForgotPasswordComponent';
import ResetPasswordComponent from 'src/components/login/forgotPassword/ResetPasswordComponent';
import ForgotPasswordEmailLinkComponent from 'src/components/login/forgotPassword/ForgotPasswordEmailLinkComponent';
// import { ENCRYPTION_KEY } from 'src/constants/constants';
import { decrypTextCall } from 'src/effects/api/api.userAuth';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { parse } from 'querystring';

class LoginContainer extends React.Component<any, any> {
    state = {
        spacing: '16',
        componentType: LoginEnum.Login,
        email: ''
    };

    constructor(props: any) {
        super(props);
        this.loginUser = this.loginUser.bind(this);
        this.clearData = this.clearData.bind(this);
        this.verifyCaptcha = this.verifyCaptcha.bind(this);
    }

    clearData() {
        this.props.clearData()
    }

    componentDidMount() {
        this.props.getAppSettings();
        getCurrentUrl().then((currUrl: any) => {
            if (currUrl.indexOf('forgotpassword') > -1) {
                let email = currUrl.substr(currUrl.lastIndexOf('forgotpassword/') + 15, currUrl.length);
                email = email.split('+').join(' ');
                const LoginDto = {
                    email: ''
                };
                LoginDto.email = email;
                decrypTextCall(LoginDto).then((res: any) => {
                    if (res.data && res.data.payload) {
                        this.setState({ componentType: LoginEnum.ResetPassword, email: res.data.payload });
                    }
                })
            }
            else {
                const splitUrl = currUrl.split("id_token=");
                if (splitUrl.length > 1) {
                    const token = parse(window.location.hash.substring(1));
                    const LoginDto = {
                        password: token.id_token
                    };
                    this.props.loginAdUser(LoginDto);
                }
            }
        });
    }

    componentWillReceiveProps(props: any) {
        if (props.loggedInUser && props.loggedInUser.success && props.loggedInUser.success === true) {
            switch (props.loggedInUser.payload.roleId) {
                case 1:
                case 4:
                    props.history.push('/hq-admin-dashboard/0');
                    break;
                case 7:
                case 8:
                case 2:
                    props.history.push('/regional-admin-dashboard/0');
                    break;
                case 3:
                    if (props.loggedInUser.payload.isInternalUser && (props.loggedInUser.payload.activeCountryId === 0 || props.loggedInUser.payload.activeCountryId === null)) {
                        props.history.push('/country-assignment');
                    }
                    else {
                        props.history.push('/data-collector-dashboard/0');
                        // props.history.push('/surveyreports');
                    }
                    break;
                case 5:
                    props.history.push('/surveyreports');
                    break;
                case 6:
                    props.history.push('/hq-admin-dashboard/0');
                    break;
            }
        }
    }

    loginUser(data: any) {
        this.props.loginUser(data)
    }

    verifyCaptcha(captchaToken: any) {
        const LoginDto = {
            password: captchaToken
        };
        this.props.verifyCaptcha(LoginDto)
    }

    handleComponentRendering = (componentType: any) => {
        this.setState({ componentType });
    }
    render() {
        return (
            <UserAuthenticationWrapper>
                <LoaderComponent sending={this.props.show} />
                <div className="backgroundLoginImage">
                    <div className="backgroundLoginLogo">
                        <Grid container={true} spacing={0}>
                            <Grid item={true} xs={12}>
                                <Grid container={true} justify="center" spacing={0}>

                                    <Grid item={true}>
                                        <Paper className="userForm" square={true}>
                                            {
                                                this.state.componentType === LoginEnum.Login && (
                                                    <LoginComponent
                                                        loggedInUser={this.props.loggedInUser}
                                                        loginUser={this.loginUser}
                                                        handleComponentRendering={this.handleComponentRendering}
                                                        clearData={this.clearData}
                                                        appSettings={this.props.appSettings}
                                                        verifyCaptcha={this.verifyCaptcha}
                                                        isCaptchaVerified={this.props.isCaptchaVerified}
                                                    />
                                                )
                                            }
                                            {
                                                this.state.componentType === LoginEnum.ForgetPassword && (
                                                    <ForgotPasswordComponent
                                                        loggedInUser={this.props.loggedInUser}
                                                        handleComponentRendering={this.handleComponentRendering}
                                                        loginUser={this.loginUser}
                                                        appSettings={this.props.appSettings}
                                                        verifyCaptcha={this.verifyCaptcha}
                                                        isCaptchaVerified={this.props.isCaptchaVerified}
                                                    />
                                                )
                                            }
                                            {
                                                this.state.componentType === LoginEnum.EmailLinkSuccess && (
                                                    <ForgotPasswordEmailLinkComponent
                                                        loggedInUser={this.props.loggedInUser}
                                                        handleComponentRendering={this.handleComponentRendering}
                                                        loginUser={this.loginUser}
                                                    />
                                                )
                                            }
                                            {
                                                this.state.componentType === LoginEnum.ResetPassword && (
                                                    <ResetPasswordComponent
                                                        loggedInUser={this.props.loggedInUser}
                                                        handleComponentRendering={this.handleComponentRendering}
                                                        loginUser={this.loginUser}
                                                        email={this.state.email}
                                                    />
                                                )
                                            }
                                        </Paper>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>

                        <Carousel className="login-carousel" autoPlay={true} showThumbs={false} infiniteLoop={true} showIndicators={false} showStatus={false} showArrows={false}
                            interval={5000}>
                            {/* <div className="login-carousel-bg1">                            
                                {/* <img src={CarouselImg1} alt="Login Carousel Child Image"/> }
                            </div> */}
                            <div className="login-carousel-bg login-carousel-bg1" />
                        </Carousel>

                    </div>
                </div>
            </UserAuthenticationWrapper>
        );
    }
}

const mapStateToProps = (state: any) => {
    // console.log("loginContainer - state:", state);
    return {
        show: state.common.show,
        loggedInUser: state.userAuth.loggedInUser,
        appSettings: state.userAuth.appSettings,
        isCaptchaVerified: state.userAuth.isCaptchaVerified
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        loginUser: (data: any) => dispatch(loginUser(data)),
        loginAdUser: (data: any) => dispatch(loginAdUser(data)),
        clearData: () => dispatch(clearUser()),
        getAppSettings: () => dispatch(getAppSettings()),
        verifyCaptcha: (data: any) => dispatch(verifyCaptcha(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);



// WEBPACK FOOTER //
// ./src/containers/LoginContainer.tsx